import { render, staticRenderFns } from "./IncludeCommentDialog.vue?vue&type=template&id=c1ed6c40"
import script from "./IncludeCommentDialog.vue?vue&type=script&lang=ts"
export * from "./IncludeCommentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports